
export default {
  host: 'http://st.chinca.org',
  // host: 'http://192.168.3.78',
  port: '80'
}



// WEBPACK FOOTER //
// ./src/api/index.js